import {Space, Form, Button, Table, message, Input, Card} from "antd";
import { ImportOutlined, DownloadOutlined, CloudUploadOutlined, SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import {useEffect, useState} from "react";
import service from "../../../@services";
import AuthComponent from "../../../components/AuthComponent";
import DownloadList from "../components/ShowDownloadList";
import EexelUpload from "../components/EexelUpload";
import EditVirtual from "../components/EditVirtual";
import HistoryList from "../components/HistoryList";
import ShopSelect from "../../../components/BaseInfoSelects/StoreSelectBase";
import CategorySelect from "../../../components/CategorySelect";
import * as Utils from "../../../@utils";
import BatchPriceUpdate from "../../Product/components/BatchPriceUpdate";
export default function Inventory(props) {
    const [form] = Form.useForm()
    const [skuId, setSkuId] = useState('')
    const [loading, setLoading] = useState(false)
    const [storeCode, setStoreCode] = useState(null)
    const [visible, setVisible] = useState(false)
    const [excelVisible, setExcelVisible] = useState(false)
    const [historyVisible, setHistoryVisible] = useState(false)
    const [tableData, setTableData] = useState([])
    const [EditVisible, setEditVisible] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [pagination, setPagination] = useState({})
    const rowSelection = {
        selectedRowKeys,
        onChange: (rowKey,row) => {
            setSelectedRowKeys(rowKey)
            setSelectedRows(row)
        }
    };
    useEffect(() => {
        onSearch()
    }, [storeCode]);
    const columns = [
        {
            title: '序号',
            dataIndex: '',
            key: 'index',
            render: (text,record,index)=> index+1 },
        {
            title: '商品名称',
            dataIndex: 'productName',
            render: (text, record) => (
                <div style={{ fontSize: 12 }}>
                    <div style={{ color: '#1890ff' }}>{record.productName}</div>
                    <div>商品编码：{record.productCode}</div>
                    <div>商品条码：{record.barcode}</div>
                </div>
            )
        },
        {
            title: '商品类别',
            dataIndex: 'categoryName'
        },
        {
            title: '规格',
            dataIndex: 'specification'
        },
        {
            title: '单位',
            dataIndex: 'unit'
        },
        {
            title: '当前剩余库存',
            dataIndex: 'stock',
            render: (text) => (
                <div style={{ fontSize: 12 }}>
                    {text || '-'}
                </div>
            )
        },
        {
            title: '操作',
            width: '150px',
            dataIndex: '',
            render: (text,record,index) => (
                <Space style={{flexWrap: 'wrap'}}>
                    <AuthComponent authKey="/inventory/stock/history/online"><Button onClick={()=>showHistoryList(record.skuId)} type="link">修改记录</Button></AuthComponent>
                </Space>
            ),
        }
    ]
    const setDefaultStore = res => {
        form.setFieldsValue({ storeCode: res.storeCode })
        setStoreCode(res.storeCode)
    }
    const setCategory = (res, selected) => {
        form.setFieldsValue({
            categoryCode: selected.length ? selected[selected.length - 1].id : ''
        })
    }
    const onSearch = () => {
        if(!storeCode){
            // message.warning('请选择门店');
            return
        }
        const params = Object.assign({},form.getFieldsValue(),{ pageIndex: 1, pageSize: 10})
        getMainData(params)
    }
    const handleTableChange = (pagination) => {
        setPagination(pagination)
        const params = Object.assign({},form.getFieldsValue(),{ pageIndex: pagination.current, pageSize: pagination.pageSize})
        getMainData(params)
    }
    const getMainData = async (params) => {
        params &&
        params.storeCode &&
        setStoreCode(params.storeCode)
        setLoading(true)
        const data = await service.inventory.getvirtualList(params)
        setLoading(false)
        if(data){
            setTableData(data.result)
            setPagination({
                showSizeChanger: true,
                showQuickJumper: true,
                current: data.pageIndex,
                pageSize: data.pageSize,
                total: data.recordCount
            })
        }
    }
    const exportProduct = async () => {
        const params = Object.assign({},form.getFieldsValue(),{ skuIds: selectedRowKeys})
        const file = await service.inventory.downLoadOnline(params)
        const filename = '线上销售库存报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
        Utils.download(file, filename)
    };

    const showHistoryList = (skuId) => {
        setSkuId(skuId)
        setHistoryVisible(true)
        // props.history.push(`/inventory/stock/list/virtual/history?actId=${skuId}&storeCode=${storeCode}`)
    }

    const showEditVirtual = () => {
        if(selectedRows.length===0){
            message.warning('请选择商品');
            return
        }
        setEditVisible(true)
    }
    return (
        <>
            <Card>
                <Form
                    form={form}
                    style={{ marginBottom: -20 }}
                    wrapperCol={{ style: { marginBottom: 20, marginRight: 20 } }}
                    layout='inline'>
                    <Form.Item name='storeCode' label='所属门店'>
                        <ShopSelect
                            style={{ width: 160 }}
                            OnOptionsLoad={setDefaultStore}
                            keyVal='storeCode'
                        />
                    </Form.Item>
                    {/* </Col>
          <Col span={7}> */}
                    <Form.Item name='categoryCode' label='商品类别'>
                        <CategorySelect
                            changeOnSelect
                            style={{ width: 160 }}
                            onChange={setCategory}
                        />
                    </Form.Item>
                    {/* </Col>
          <Col span={7}> */}
                    <Form.Item name='productInfo' label='商品信息'>
                        <Input placeholder='商品名称/条码/商品编码' />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <AuthComponent authKey='/inventory/stock/list/virtual'>
                                <Button
                                    ghost
                                    type='primary'
                                    loading={loading}
                                    onClick={onSearch}
                                    icon={<SearchOutlined />}>
                                    查询
                                </Button>
                            </AuthComponent>
                            <AuthComponent authKey='/inventory/stock/list/virtual'>
                                <Button
                                    type='primary'
                                    ghost
                                    onClick={() => form.resetFields()}
                                    icon={<ReloadOutlined />}>
                                    重置
                                </Button>
                            </AuthComponent>
                        </Space>
                    </Form.Item>
                    {/* </Col>
        </Row> */}
                </Form>
            </Card>
            <Space style={{ display: "flex", justifyContent: "space-between", background: "#ffffff", padding: "15px", marginBottom: "-10px", marginTop: '20px',position: 'relative' }}>
                <Space>
                    <AuthComponent authKey="/inventory/stock/batch/update">
                        <Button type="primary" onClick={showEditVirtual}>批量设置销售库存</Button>
                    </AuthComponent>
                    <AuthComponent authKey="/product/price/import-stock">
                        <Button type="primary" onClick={()=>setExcelVisible(true)} icon={<ImportOutlined />}>Excel导入</Button>
                    </AuthComponent>
                    <AuthComponent authKey="/inventory/stock/export/online">
                        <Button type="primary" onClick={exportProduct} icon={<DownloadOutlined />}>导出</Button>
                    </AuthComponent>
                </Space>
                <AuthComponent authKey="/product/price/import-stock">
                    <Button type="link" icon={<CloudUploadOutlined />} onClick={()=>setVisible(true)}>导入记录</Button>
                </AuthComponent>
            </Space>
            <Table
                rowKey={record=>record.skuId}
                dataSource={tableData}
                rowSelection={rowSelection}
                pagination={pagination}
                loading={loading}
                columns={columns}
                onChange={handleTableChange}
            />

            <DownloadList
                visible={visible}
                type={[3]}
                close={()=>{setVisible(false)}}
            />

            <EexelUpload
                visible={excelVisible}
                storeCode={storeCode}
                close={()=>{setExcelVisible(false)}}
            />

            <EditVirtual
                visible={EditVisible}
                data={selectedRows}
                storeCode={storeCode}
                close={()=>{setEditVisible(false)}}
                // batchUpdatePrice={updatePrice}
            />

            <HistoryList
                visible={historyVisible}
                actId={skuId}
                storeCode={storeCode}
                close={()=>{setHistoryVisible(false)}}
            />
        </>
    )
}
